// // buyer-page.jsx
// import React, { useEffect, useState } from "react";
// import BuyerService from "./buyer.service";
// import BuyerInput from "./buyer-input";

// export default function BuyerPage(props) {
//   const [ready, setReady] = useState(false);
//   const [optionalColumns, setOptionalColumns] = useState(false);

//   useEffect(() => {
//     (async () => {
//       let columnList= await BuyerService.initBuyerOptionalColumns();
//       console.log(columnList)
      
//       setOptionalColumns(columnList);
//       setReady(true);
//     })();
//   }, []);

//   if (!ready) return null; // or a loader

//   return <BuyerInput {...props} optionalColumns={optionalColumns} />;
// }




// buyer-page.jsx
import React, { useEffect, useState } from "react";
import BuyerService from "./buyer.service";
import BuyerInput from "./buyer-input";

export default function BuyerPage(props) {
  const [ready, setReady] = useState(false);
  const [optionalColumns, setOptionalColumns] = useState(null);

  let columns = []
  useEffect(() => {
    let alive = true;

    (async () => {
      try {
        const columnList = await BuyerService.initBuyerOptionalColumns();
        if (!alive) return;
        setOptionalColumns(columnList);
      } catch (e) {
        console.error("initBuyerOptionalColumns failed:", e);
        if (!alive) return;
        setOptionalColumns([]); // safe fallback
      } finally {
        if (!alive) return;
        setReady(true);
      }
    })();

    return () => {
      alive = false;
    };
  }, []);

  if (!ready) {
    return (
      <div className={props?.IsDialog == true ? `content-wrapper`:'irtiza'}>
        <div className="page-loader" role="status" aria-live="polite" aria-busy="true">
          <div className="spinner" aria-hidden="true" />
          <div className="loader-text">Loading…</div>
        </div>
      </div>
    );
  }

  return (
    <div >
      {/* <BuyerInput {...props} optionalColumns={optionalColumns} /> */}
      
  <div >
    <BuyerInput {...props}  IsDialog={props?.IsDialog || false} optionalColumns={optionalColumns} BusinessType={props?.BusinessType || 'Buyer'} />
  </div>

    </div>
  );
}
